import { Box, styled } from '@mui/material';

export const InfoReviewDetailCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
}));
